import { IntegrationV2ResponseSchema } from "@redotech/internal-ctx-client";
import * as z from "zod";

export const connectRedoContextualIntegration = {
  name: "connectRedoContextualIntegration" as const,
  input: z.object({
    integrationId: z.string(),
    events: z.array(z.string()).optional(),
  }),
  output: IntegrationV2ResponseSchema,
};
